export const eventAnalyticsEventCategory = ["identify", "track"] as const;
export const eventAnalyticsInteractionType = ["Active", "Passive"] as const;
